export const getCoveragesDiscount = (coverages, type) => {
  return coverages
    ? coverages.reduce((discount, c) => {
        return c.type === type ? discount + c.amount : discount;
      }, 0)
    : 0;
};
